import { render, staticRenderFns } from "./importDialogup.vue?vue&type=template&id=1b8e065e"
import script from "./importDialogup.vue?vue&type=script&lang=js"
export * from "./importDialogup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports